import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import * as userService from "../../services/userService";
import { Page1 } from "./Consent/Page1";
import { Page2 } from "./Consent/Page2";

export const pathRoot = "/setupdata/consent";

class Consent extends React.Component {
	constructor(props) {
		super(props);
		let consent = null;

		consent = userService.getUserSettings().consent;

		if (consent) {
		} else {
			consent = userService.createConsent();
		}

		this.state = {
			consent: consent,
		};
	}

	handleSaveFailure = (error) => {
		console.error(`Error saving data in ${pathRoot}: `, error);
		// this.props.history.push("/dashboard");
	};

	render() {
		return (
			<Switch>
				<Route path={`${pathRoot}/1`}>
					<Page1 />
				</Route>
				<Route path={`${pathRoot}/2`}>
					<Page2
						consentSettings={this.state.consent}
						onSaveFailure={this.handleSaveFailure}
					/>
				</Route>
				<Redirect from={pathRoot} to={`${pathRoot}/1`} />
			</Switch>
		);
	}
}

export default withRouter(Consent);
